import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const Redirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/app/realtime', { replace: true });
  });

  return null;
};
